<template>
  <div class="QASetting">
    <div class="header">
      <div>
      <iconSetting/>
      <span>Q&A設定</span>
      <Select :defaultValue="area" @input="area=$event" :width="'235px'">
        <option value="成美文化園">成美文化園</option>
        <option v-for="(rest,  r) in restaurants" :key="`rest-${r}`" :value="rest">{{rest}}</option>
      </Select>
      <div class="MessageSelect squr" label="" :style="{display: 'none'}">
        <input type="radio" v-model="location" value="ＯＯ餐廳" @change="getQuestion">
      </div>
      <button class="addQABtn" @click="addQA=true"><iconPlus :invert="true"/>新增Q&A</button>
      </div>
      <div v-if="editOrder" class="btnRight">
        <button class="cancel" @click="editOrder=false;getQuestion()">取消</button>
        <button class="save" @click="saveOrder">儲存</button>
      </div>
      <div v-else class="btnRight">
        <button class="editOrder" @click="editOrder=true">編輯排序</button>
      </div>
    </div>
    <div :style="{overflowY: 'auto'}">
    <table>
      <thead>
        <tr>
          <th>No.</th>
          <th>問題名稱</th>
          <th>編輯</th>
          <th>刪除</th>
        </tr>
      </thead>
      <draggable v-model="questions" tag="tbody" v-if="editOrder" group="questions" @start="drag=true" @end="drag=false">
        <tr v-for="(qa, i) in questions" :key="`qa-${i}`">
          <td><iconHam/></td>
          <td>{{qa.question}}</td>
          <td><iconEdit color2="var(--color-checked)"/></td>
          <td><iconDelete color2="#FFFFFF" color="var(--color-confirm)"/></td>
        </tr>
        <tr :style="{height: '-webkit-fill-available'}"></tr>
      </draggable>
      <tbody v-else >
        <tr v-for="(qa, i) in questions" :key="`qa-${i}`" :class="[qaSelect && qa._id===qaSelect._id?'actived':'']">
          <td @click="qaSelect=qa">Q{{qa.order}}</td>
          <td @click="qaSelect=qa">{{qa.question}}</td>
          <td @click="editQA(qa)"><iconEdit color2="var(--color-checked)"/></td>
          <td @click="deleteQ=qa"><iconDelete color2="#FFFFFF" color="var(--color-confirm)"/></td>
        </tr>
        <tr :style="{height: '-webkit-fill-available'}"></tr>
      </tbody>

    </table>
    </div>
    <template v-if="addQA">
      <div>新增Q&A</div>
      <div>
        <div class="scrollBox">
          <div class="inputColFlex" :style="{display: 'none'}">
            <div :style="{marginRight: '10px'}">類別:</div>
            <div class="MessageSelect squr" label="">
              <input type="radio" v-model="category" value="ＯＯ餐廳">
            </div>
          </div>
          <div class="inputColFlex">
            <div :style="{marginRight: '20px'}">問題名稱:</div>
            <input type="text" v-model="question">
          </div>
          <div class="inputTextBlock">
            <div>回答</div>
            <quillEditor v-model="answer"
                ref="myQuillEditor"
                :options="editorOption"/>
          </div>
          <div class="btnsCoupon">
            <button class="cancel" @click="addQA=false">取消</button>
            <!-- <button class="saveAs">另存</button> -->
            <button class="confirm" @click="newPost">確定</button>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="editItem">
      <div>編輯Q&A</div>
      <div>
        <div class="scrollBox">
          <div class="inputColFlex" :style="{display: 'none'}">
            <div :style="{marginRight: '10px'}">類別:</div>
            <div class="MessageSelect squr" label="">
              <input type="radio" v-model="category" value="ＯＯ餐廳">
            </div>
          </div>
          <div class="inputColFlex">
            <div :style="{marginRight: '20px'}">問題名稱:</div>
            <input type="text" v-model="question">
          </div>
          <div class="inputTextBlock">
            <div>回答</div>
            <quillEditor v-model="answer"
                ref="myQuillEditor"
                :options="editorOption"/>
          </div>
          <div class="btnsCoupon">
            <button class="cancel" @click="cancelEdit">取消</button>
            <!-- <button class="saveAs">另存</button> -->
            <button class="confirm" @click="editPost">確定</button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div>Q&A詳情</div>
      <div v-if="qaSelect">
        <div class="scrollBox">
          <div class="QA Q" :label="`Q${qaSelect.order}:`">{{qaSelect.question}}</div>
          <div class="QA A" :label="`A${qaSelect.order}:`" >
            <p v-html="qaSelect.answer.replace(/\n/ig, '<br>')"></p>
          </div>
          <!-- <div class="QA" :label="''"><img class="imageBox" :src="qaSelect.image"></div> -->
        </div>
      </div>
    </template>
    <div class="phone" v-if="qaSelect&&(!addQA&&!editItem)" :class="phoneShow?'sin':'sout'">
      <div class="showBtn" @click="phoneShow=!phoneShow"><span>預覽</span><span v-if="phoneShow">⯆</span><span v-else>⯅</span></div>
      <div class="phoneTitle">
        <div>{{title}}</div>
        <div>{{host}}</div>
      </div>
      <div class="phoneHeader">線上客服</div>
      <div class="phoneContent">
        <div>Q: {{qaSelect.question}}</div>
        <div>A:</div>
        <p class="ans" v-html="qaSelect.answer.replace(/\n/ig, '<br>')"></p>
        <!-- <div><img class="phoneImageBox" :src="qaSelect.image"></div> -->
      </div>
    </div>
    <div class="phone" v-if="addQA||editItem" :class="phoneShow?'sin':'sout'">
      <div class="showBtn" @click="phoneShow=!phoneShow"><span>預覽</span><span v-if="phoneShow">⯆</span><span v-else>⯅</span></div>
      <div class="phoneTitle">
        <div>{{title}}</div>
        <div>{{host}}</div>
      </div>
      <div class="phoneHeader">線上客服</div>
      <div class="phoneContent">
        <div>Q: {{question}}</div>
        <div>A:</div>
        <p class="ans" v-html="answer"></p>
      </div>
    </div>
    <comfirmVue :show="!!deleteQ"  v-if="!!deleteQ" :label="'刪除Q&A'" :text='`確定要刪除"${deleteQ.question}"嗎?`'
    @confirm="deleteItem(deleteQ._id)" @cancel="deleteQ=null"/>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import draggable from 'vuedraggable'
import iconHam from '../SVG/iconHam'
import iconDelete from '../SVG/iconDelete'
import iconEdit from '../SVG/iconEdit'
import iconPlus from '../SVG/iconPlus'
import iconSetting from '../SVG/toggleIcon/iconSetting'
import Select from '../components/select.vue'
import { deleteapi, postapi, uploadimage, getapi } from '../store/fetch'
import { mapState } from 'vuex'
export default {
  name: 'QASetting',
  components: {
    draggable,
    iconHam,
    iconEdit,
    iconDelete,
    iconPlus,
    iconSetting,
    quillEditor,
    Select
  },
  computed: {
    title () {
      return process.env.VUE_APP_NAME
    },
    host () {
      return window.location.origin
    },
    ...mapState({
      restaurants: 'restaurants',
      defaultStore: 'defaultStore'
    })
  },
  data () {
    return {
      deleteQ: null,
      area: null,
      editorOption: {
        debug: 'Answer',
        placeholder: '請輸入答案'
      },
      phoneShow: false,
      editID: null,
      editItem: false,
      editOrder: false,
      addQA: false,
      location: 'ＯＯ餐廳',
      image: null,
      questions: [],
      question: null,
      answer: null,
      category: 'ＯＯ餐廳',
      qaSelect: null
    }
  },
  mounted () {
    this.area = this.defaultStore || this.restaurants[0]
  },
  async created () {
    await this.getQuestion()
    if (this.questions.length > 0) {
      this.qaSelect = this.questions[0]
    }
  },
  watch: {
    area () { this.getQuestion() },
    locaion () { this.getQuestion() },
    addQA () {
      this.question = null
      this.answer = null
      this.iamge = null
      this.category = this.location
    }
  },
  methods: {
    cancelEdit () {
      this.editID = null
      this.question = null
      this.answer = null
      this.image = null
      this.category = 'ＯＯ餐廳'
      this.editItem = false
    },
    editQA (item) {
      this.editID = item._id
      this.question = item.question
      this.answer = item.answer
      this.image = { filename: item.image }
      this.category = item.category
      this.editItem = true
    },
    async saveOrder () {
      const PromiseArray = this.questions.map((e, i) => {
        return postapi(`qa/${e._id}`, { order: (i + 1) })
      })
      Promise.all(PromiseArray).then(() => {
        this.editOrder = false
        this.getQuestion()
      })
    },
    async getQuestion () {
      // console.log('location', this.location)
      const questions = await getapi('qa?' + new URLSearchParams({ area: this.area }))

      if (this.qaSelect) {
        const qaSelect = questions.find(e => e._id === this.qaSelect._id)
        // console.log(this.qaSelect, qaSelect)
        if (!qaSelect) {
          this.qaSelect = questions[0]
        } else {
          this.qaSelect = qaSelect
        }
      }
      this.questions = questions
    },
    async editPost () {
      const data = { area: this.area }
      if (this.question !== this.qaSelect.question) { data.question = this.question }
      if (this.answer !== this.qaSelect.answer) { data.answer = this.answer }
      if (this.category !== this.qaSelect.category) { data.category = this.category }
      if (this.image.filename !== this.qaSelect.image) { data.image = this.image ? this.image.filename : null }
      const ret = await postapi(`qa/${this.editID}`, data)
      if (ret) {
        this.location = ret.category
        await this.getQuestion()
        this.qaSelect = ret
        this.editItem = false
      }
    },
    async newPost () {
      const data = {
        question: this.question,
        answer: this.answer,
        category: this.category,
        area: this.area
      }
      console.log('new post', data)
      const ret = await this.$store.dispatch('put', { url: 'qa', body: data })
      if (ret) {
        this.questions.push(ret)
        this.addQA = false
      }
    },
    async deleteItem (id) {
      const ret = await deleteapi(`qa/${id}`)
      if (ret) {
        const index = this.questions.map(e => e._id).indexOf(id)
        this.questions.splice(index, 1)
        this.deleteQ = null
      }
    },
    async deleteImage (filename) {
      const ret = await deleteapi(`images${filename}`)
      if (ret) {
        // console.log(ret, 'deleteImage')
        const ret2 = await postapi(`qa/${this.editID}`, { image: null })
        this.image = { filename: ret2.image }
      }
    },
    async uploadFile (event, folder) {
      const ret = await uploadimage(event, folder)
      const image = ret
      image.filename = `/qa/${image.filename}`
      this.image = image
    }
  }

}
</script>

<style lang="scss">
.QASetting {
  .A p * {
  }
  p, h1, h2 {
    font-family: Roboto;
  }
  strong {
    font-weight: 700;
  }
  em {
    font-style: italic;
  }
.ql-container {
    height: fit-content;
}
.ql-editor {
  height: fit-content;
  font-size: 24px;
}
.ql-size-large { font-size: large; }
.ql-align-center {
  text-align: center;
}
img {
  width: 100%;
}
.ql-indent-2 {
  text-indent: 2em;
}
.ql-indent-1 {
  text-indent: 1em;
}
}
</style>
<style lang="scss" scoped>
table {
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  tr {
    display: table-row;
  }
  thead {
    display: table-header-group;
    tr {
      height: 40px;
      background-color: var(--color-bar);
    }
  }
  tbody {
    display: table-row-group;
    tr {
      height: 65px;
      border-bottom: 1px solid #CACACA;
    }
  }
}
.ans {
  width: 100%;
  box-sizing: border-box;
}

.sin {
    animation: sin 0.5s forwards;
    -webkit-animation: sin 0.5s forwards;
}

.sout {
    animation: sout 0.5s forwards;
    -webkit-animation: sout 0.5s forwards;
}

@keyframes sin {
    100% { transform: translateX(0%); }
}

@-webkit-keyframes sin {
    100% { -webkit-transform: translateX(0%); }
}

@keyframes sout {
    0% { transform: translateX(0%); }
    100% { transform: translateY(calc(100%));  }
}

@-webkit-keyframes sout {
    0% { -webkit-transform: translateX(0%); }
    100% { -webkit-transform: translateX(calc(100%)); }
}
.showBtn {
  position: absolute;
  top: -40px;
  left: -1px;
  right: -1px;
  height: 40px;
  background-color: var(--color-checked);
  color: #FFFFFF;
  text-align: start;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 24px;
  border-radius: 5px 5px 0 0;
  box-sizing: border-box;
}
.phoneImageBox {
  width: 100%;
}
.phoneContent {
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.1em;
  color: #787878;
  box-sizing: border-box;
  padding: 30px;
  text-align: start;
  width: calc(100% - 60px);
  overflow-y: auto;
  &>:nth-child(1) {
    color: var(--color-pri);
  }
}
tr.actived {
  background-color: var(--color-bar);
}
.phone {
  transform: translateY(calc(100% - 50px));
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  right: 700px;
  width: 390px;
  height: 844px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  background-color: #FFFFFF;
  &::before {
    content: '';
    display: inline-flex;
    background-image: url(./phoneHeader.svg);
    width: 100%;
    height: 44px;
  }
  .phoneTitle {
    width: 100%;
    height: 50px;
    background-color: #F8F7F7;
    text-align: start;
    padding-inline: 29px;
    display: flex;
    justify-items: center;
    align-items: flex-start;
    flex-direction: column;
    box-sizing: border-box;
    &>div:nth-child(1) {
      margin-top: 9px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      letter-spacing: -0.333333px;
      color: #000000;
    }
    &>div:nth-child(2) {
      margin-top: 3px;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 11px;
      letter-spacing: -0.333333px;
      color: #999999;
    }
  }
  .phoneHeader {
    width: 100%;
    height: 55px;
    background-color: var(--color-pri);
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    letter-spacing: 2px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .phoneContent {
    height: 695px;
    width: 100%;
    background-image: url(./phoneBg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
.QA {
  padding-right: 20px;
  display: flex;
  text-align: start;
  &>p {
    // background-image: url(./phoneBg.png);
    // border-left: 1px solid var(--color-border);
  }
  &>img {
    width: 520px;
  }
  &::before {
    content: attr(label);
    display: inline-flex;
    min-width: 55px;
  }
  &.Q {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
  }
  &.A {
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    letter-spacing: 0.1em;
    color: #7D7D7D;
  }
}
.btnRight {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 37px;
  &>button:not(.editOrder) {
    border: none;
    width: 80px;
    height: 40px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    &::before {
      content: '';
      display: inline-flex;
      align-items: center;
    }
    &.cancel {
      background-color: #C4C4C4;
      &::before {
        background-image: url(./cancel.svg);
        width: 23px;
        height: 23px;
        background-size: 23px;
      }
    }
    &.save {
      background-color: var(--color-confirm);
      &::before {
        background-image: url(./save.svg);
        width: 20px;
        height: 20px;
        background-size: 20px;
      }
    }
  }
}
.editOrder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 40px;
  background: var(--color-checked);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  &::before {
    content: '';
    display: inline-flex;
    align-items: center;
    width: 20px;
    height: 20px;
    background-position: center;
    background-image: url(./sort.svg);
  }
}
.btnsCoupon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 28px;
  button {
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.saveAs {
      background: var(--color-pri);
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
label#uploadimage {
  width: 550px;
  height: 412.5px;
}
.uploadimage {
  margin-right: auto;
  width: 550px;
  height: 412.5px;
  background-image: url(./upload.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 275px;
    top: 243px;
    transform: translateX(-50%);
  }
}
.imageField {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 22px;
  &::before {
    content: attr(label);
    display: inline-flex;
    width: 80px;
    text-align: start;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    color: var(--color-letter);
    text-align: right;
  }
  #uploadimage {
    margin-left: 20px;
  }
}
.scrollBox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
}
.inputTextBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: fit-content;
  gap: 20px;
  &>div:nth-child(1) {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
.inputColFlex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
  &>div:nth-child(1) {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
  }
}
textarea {
  width: 615px;
  height: 390px;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 16px 22px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
}
input[type=text] {
  padding-inline: 14px;
  box-sizing: border-box;
  width: 500px;
  height: 40px;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  color: var(--color-letter);
}
th {

}
td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
}
td, th {
  box-sizing: border-box;
  &:nth-child(1) { text-align: start; padding-left: 25px; width: 109px; }
  &:nth-child(2) { text-align: start; width: inherit; }
  &:nth-child(3) { text-align: center; width: 70px; }
  &:nth-child(4) { text-align: center; width: 107px; padding-right: 37px; }

}
.scrollBox {
  margin-right: 10px;
  overflow-y: scroll;
  margin-block: 26px 20px;
  height: calc(100% - 46px);
  padding-inline: 36px 15px;
  &::-webkit-scrollbar {
    width: 7px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--color-pri);
  }
  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 20px;
    background-color: #d8d8d8;
    border: 2px solid #FFFFFF!important;
  }
}
.MessageSelect {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  input[type=radio] {
    &::before {
      content: attr(value);
    }
    background-color: #C4C4C4;
    color: #FFFFFF;
    &:checked {
      background-color: var(--color-checked);
      color: #FFFFFF;
    }
  }
  &.squr > input[type=radio] {
    border-radius: 3px;
    width: fit-content;
    padding-inline: 24px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    appearance: none;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
  }
}
.QASetting {
  padding-inline: 18px 9px!important;
  display: grid;
  grid-template-columns: 1fr 695px;
  grid-template-rows: 89px 1fr;
  grid-template-areas: "d1 d3" "d2 d4";
  &>:nth-child(1) { grid-area: d1; box-sizing: border-box;}
  &>:nth-child(2) { grid-area: d2; box-sizing: border-box;}
  &>:nth-child(3) { grid-area: d3; box-sizing: border-box;}
  &>:nth-child(4) { grid-area: d4; box-sizing: border-box; overflow-y: auto;}
  &>:nth-child(1), &>:nth-child(2) {
    border-right: 1px solid var(--color-border);
  }
  &>:nth-child(3) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid var(--color-border);
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    letter-spacing: 0.15em;
    color: var(--color-pri);
    padding-inline: 28px;
  }
  .content {
    display: grid;
    grid-template-columns: 645px 1fr;
    grid-template-rows: calc(100vh - 89px);
    &>:nth-child(1) {
      border-right: 1px solid var(--color-border);
    }
    &>div {
      width: 100%;
      height: 100%;
      padding-block: 28px;
      padding-inline: 50px;
      box-sizing: border-box;
    }
  }
 }
.header {
  height: 89px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
  button.addQABtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 170px;
    height: 50px;
    background: var(--color-checked);
    border-radius: 50px;
    border: none;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    margin-right: 54px;
  }
}
</style>
